import React, { useEffect, useState } from "react"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  exportMonitorQuantificationReportBasedOrganization,
  getMonitorQuantificationReportBasedOrganization,
} from "store/monitor-reports/monitor-report-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
  getMonitorProjects,
  getMonitorProvinces,
} from "store/monitor-dashboard/monitor-dashboard-action"
import { getMonitorConsumptionsProjects } from "store/monitor-consumption/monitor-consumption-action"
import MonitorQuantificationOrganizationReportListComponent from "components/MonitorReports/QuantificationBasedOrganization"

const MonitorQuantificationOrganizationReport = () => {
  //meta title
  document.title = "Quantification Based Organization Report"

  const [params, setParams] = useState({})
  const { data, error, loading, exportStatus } = useSelector(state => ({
    data: state.monitorReports.monitorQuantificationReport.data,
    error: state.monitorReports.monitorQuantificationReport.error,
    loading: state.monitorReports.monitorQuantificationReport.loading,
    exportStatus: state.monitorReports.monitorQuantificationExport,
  }))

  const dispatch = useDispatch()
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.MONITOR_QUANTIFICATION_ORG
  )

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(getMonitorQuantificationReportBasedOrganization(link.url, params))
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setParams(prev => {
      return { ...prev, pageNumber: value }
    })
    dispatch(
      getMonitorQuantificationReportBasedOrganization(undefined, {
        ...params,
        pageNumber: value,
      })
    )
  }

  // Trigger export process when Export button is clicked
  const onExport = () => {
    dispatch(exportMonitorQuantificationReportBasedOrganization(params, visibleKeys))
  }

  // fetch QO Report and other data based filter select box needs
  useEffect(() => {
    dispatch(getMonitorQuantificationReportBasedOrganization())
    dispatch(getMonitorProjects())
    dispatch(getMonitorIps())
    dispatch(getMonitorProvinces())
  }, [])

  // Updates search value when a new search is performed
  const onSearchHandler = filter => {
    setParams(filter)
    dispatch(getMonitorQuantificationReportBasedOrganization(undefined, filter))
  }

  return (
    <React.Fragment>
      <Breadcrumbs
        title={"Monitor"}
        breadcrumbItem={"Quantification Based Organization Report"}
      />
      {/* Monitor Quantification based organization Compoent */}
      <MonitorQuantificationOrganizationReportListComponent
        data={data}
        error={error}
        loading={loading}
        onSearchHandler={onSearchHandler}
        onExportBtnClick={onExport}
        exportStatus={exportStatus}
        onPageClick={onPageClick}
        onChangeRowNumber={onChangeRowNumber}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default MonitorQuantificationOrganizationReport
